// removed by extract-text-webpack-plugin
module.exports = {"container":"FRo4ITyxZanuEqOAb22VE","customer":"_1GYbBqAQAhvqbvxDlo0cfz","callDuration":"_2DyPHohg3Xum8O8hEmJA13"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-429e3682","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/live-coach-call/call-info/call-info.less
// module id = UAwM
// module chunks = 1